// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "wp-content/themes/betano-blog/js/" + chunkId + "." + {"22":"afa3b896","48":"a08132b8","155":"12af5cd4","246":"6dbeadde","262":"1372c9dc"}[chunkId] + ".js";
};